export default "__VITE_ASSET__DGoV_dWZ__"